import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import Bots from "./bots/bots.wrapper"
import { createTheme } from "./theme"
import { ThemeProvider } from '@mui/material/styles';
import zoidInit from './zoid/init';


async function init() {
  const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT
  const RENDERER_ENDPOINT = process.env.REACT_APP_RENDERER_ENDPOINT
  await zoidInit();
  const element = document.getElementById('root');

 const getMainColor = () => {
    const query = new URLSearchParams(window.location.search);
    let v = query.get('colorMain')
    return v
}

const theme = createTheme({
  mainColorOverride: getMainColor() || false,
  colorPreset: 'client',
  contrast: 'normal',
  direction: 'ltr',
  layout: 'vertical',
  navColor: 'evident',
  paletteMode: 'light',
  responsiveFontSizes: true,
  stretch: false,
  });
  if (element) {
    const root = ReactDOM.createRoot(element);
    root.render(
      <React.StrictMode>
         <ThemeProvider theme={theme}>
                    <meta name="theme-color"
                          content={theme.palette.primary.main}/>
                          <Bots user={null} backendEndpoint={BACKEND_ENDPOINT} rendererEndpoint={RENDERER_ENDPOINT} extension={false}/>
                      </ThemeProvider>
      </React.StrictMode>
    );
  }
}
init()